/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.isSearchContext){ ;
__p += '\n  \n  <i class="carrot-crumb fa fa-chevron-left"></i>\n  \n  <div class="folder-breadcrumb action-clear-search" data-folder-id="' +
__e(data.currentFolder.get('id')) +
'">\n    Back to ' +
__e(data.currentFolder.get('name')) +
'\n  </div>\n  \n';
 } else { ;
__p += '\n\n  ';
 if(data.dropdownBreadcrumbs.length) { ;
__p += '\n    <div class="breadcrumbs-dropdown-wrapper action-breadcrumbs-dropdown">\n      ' +
__e(data.dropdownBreadcrumbs.length) +
' Folders\n      <div class="breadcrumbs-dropdown">\n      ';
_.each(data.dropdownBreadcrumbs, function(dropdownItem) { ;
__p += '\n        <div class="breadcrumbs-option action-navigate-to-folder" data-folder-id="' +
__e(dropdownItem.get('id')) +
'">\n          ' +
__e(dropdownItem.get('name')) +
'\n        </div>\n      ';
});;
__p += '\n      </div>\n    </div>\n    <i class="carrot-crumb fa fa-chevron-right"></i>\n  ';
 } ;
__p += '\n\n  ';
_.each(data.parentFolders, function(parentFolder, index) { ;
__p += '\n    <div class="folder-breadcrumb action-navigate-to-folder" data-folder-id="' +
__e(parentFolder.get('id')) +
'">\n      ' +
__e(parentFolder.get('name')) +
'\n    </div>\n    <i class="carrot-crumb fa fa-chevron-right"></i>\n  ';
 }); ;
__p += '\n\n  <div class="folder-breadcrumb current-folder">\n    ' +
__e(data.currentFolder.get('name')) +
'\n  </div>\n  \n';
 } ;
__p += '\n\n<div class="asset-display-toggle">\n  <div class="toggle-btn list-btn' +
__e(data.assetDisplayState == 'list' ? ' active' : '' ) +
'" data-display-type="list">\n    <i class="fa fa-list"></i>\n  </div>\n  <div class="toggle-btn grid-btn' +
__e(data.assetDisplayState == 'grid' ? ' active' : '' ) +
'" data-display-type="grid">\n    <i class="fa fa-th-large"></i>\n  </div>\n</div>\n\n';
 if(data.assetDisplayState == 'grid') { ;
__p += '\n<div class="sort-by-wrapper">\n  <div class="action-sort-by sort-by-button">\n    Sort by <span class="sort-selected">' +
__e(data.getSortByName(data.sortBy)) +
'</span>\n    <i class="fa fa-sort-desc"></i>\n  </div>\n  <div class="sort-by-dropdown">\n    <div class="sort-option action-sort-option" data-sort-type="date_added:desc" toggled="' +
__e(data.sortBy == 'date_added:desc' ? 'true' : 'false') +
'">\n      Date Added\n    </div>\n    <div class="sort-option action-sort-option" data-sort-type="date_modified:desc" toggled="' +
__e(data.sortBy == 'date_modified:desc' ? 'true' : 'false') +
'">\n      Date Modified\n    </div>\n    <div class="sort-option action-sort-option last-option" data-sort-type="display_filename:asc" toggled="' +
__e(data.sortBy == 'display_filename:asc' ? 'true' : 'false') +
'">\n      Name (A-Z)\n    </div>\n  </div>\n</div>\n';
 } ;
__p += '\n';
return __p
}
